import './components/app-shell';
import './components/cookie-consent';
import './pages/landing-page';
import './pages/about-page';
import './pages/agencies-page';
import './pages/blunticle-page';
import './pages/subbyswap-page';
import './pages/traviapp-page';
import './pages/tag-nfc-page';
import './pages/blog-list-page';
import './pages/contact-page';
import './pages/services-page';
import './pages/agent-director-page';
import './pages/agent-writers-page';
import './pages/agent-secretary-page';
import './pages/agent-artist-page';
import './pages/legal-page';
import { LEGAL_NOTICE_CONTENT } from './content/legal/aviso-legal';
import { PRIVACY_POLICY_CONTENT } from './content/legal/privacidad';
import { COOKIE_POLICY_CONTENT } from './content/legal/cookies';
import { initAnalytics, setupAnalyticsListener } from './lib/analytics';
import { setupSeoListener } from './lib/seo';
import { AboutPage } from './pages/about-page';
import { AgenciesPage } from './pages/agencies-page';
import { BlunticlePage } from './pages/blunticle-page';
import { SubbyswapPage } from './pages/subbyswap-page';
import { TraviappPage } from './pages/traviapp-page';
import { TagNfcPage } from './pages/tag-nfc-page';
import { BlogListPage } from './pages/blog-list-page';
import { ContactPage } from './pages/contact-page';
import { ServicesPage } from './pages/services-page';
import { LandingPage } from './pages/landing-page';
import { AgentDirectorPage } from './pages/agent-director-page';
import { AgentWritersPage } from './pages/agent-writers-page';
import { AgentSecretaryPage } from './pages/agent-secretary-page';
import { AgentArtistPage } from './pages/agent-artist-page';
import { LegalPage } from './pages/legal-page';
import { registerRoute, startRouter } from './router';

registerRoute('/', async () => new LandingPage());

registerRoute('/sobre-mi', async () => new AboutPage());

registerRoute('/agencias', async () => new AgenciesPage());

registerRoute('/blunticle', async () => new BlunticlePage());

registerRoute('/subbyswap', async () => new SubbyswapPage());

registerRoute('/traviapp', async () => new TraviappPage());

registerRoute('/tag-nfc', async () => new TagNfcPage());

registerRoute('/blunticle/agentes/director', async () => new AgentDirectorPage());

registerRoute('/blunticle/agentes/writers', async () => new AgentWritersPage());

registerRoute('/blunticle/agentes/secretario', async () => new AgentSecretaryPage());

registerRoute('/blunticle/agentes/artista', async () => new AgentArtistPage());

registerRoute('/blog', async () => new BlogListPage());

registerRoute('/contacto', async () => new ContactPage());

registerRoute('/servicios', async () => new ServicesPage());

registerRoute('/politica-privacidad', async () => {
  const page = new LegalPage();
  page.title = 'Política de Privacidad';
  page.content = PRIVACY_POLICY_CONTENT;
  return page;
});

registerRoute('/aviso-legal', async () => {
  const page = new LegalPage();
  page.title = 'Aviso Legal';
  page.content = LEGAL_NOTICE_CONTENT;
  return page;
});

registerRoute('/politica-cookies', async () => {
  const page = new LegalPage();
  page.title = 'Política de Cookies';
  page.content = COOKIE_POLICY_CONTENT;
  return page;
});

setupSeoListener();
setupAnalyticsListener();
initAnalytics();

customElements.whenDefined('app-shell').then(() => {
  startRouter();
});
